import { Outlet, useLocation } from 'react-router-dom';
import { Header, SidebarMenu } from '@components';
import './MemberLayout.scss';
import { useFilteredMembersMenuItems } from '../../utils/menu';
import { useEffect, useRef } from 'react';
import { useAuthentifiedLayout } from '@layout/AuthentifiedLayout/useAuthentifiedLayout';

export const MemberLayout = () => {
    useAuthentifiedLayout();
    const layoutRef = useRef<HTMLDivElement>(null);
    const { pathname, hash } = useLocation();
    const filteredMembersMenuItems = useFilteredMembersMenuItems();

    useEffect(() => {
        if (hash) {
            const element = document.getElementById(hash.slice(1));
            if (element) {
                layoutRef.current?.scrollTo(0, element.offsetTop);
            }
        } else {
            layoutRef.current?.scrollTo(0, 0);
        }
    }, [pathname, hash]);

    return (
        <div className="member-layout layout" data-theme="members">
            <Header />
            <div ref={layoutRef} className="rendered-page">
                <SidebarMenu items={filteredMembersMenuItems} activeParentItem={'member'} />
                <Outlet />
            </div>
        </div>
    );
};

export default MemberLayout;
